import { sortCoordinatesByDate } from 'react/utils/coordinateUtils';

/* Model */
class CoordinateModel extends App.Models.BaseModel {
    modelUrl = 'Coordinate';
    idAttribute = 'id.inc';

    color = () => {
        const color = {};
        if (!this.attributes.engineOn && this.attributes.speedKmh === 0) {
            color.border = '#000000';
            color.status = '#000000';
        } else if (this.attributes.engineOn && this.attributes.speedKmh < 5) {
            color.border = '#9419FF';
            color.status = '#9419FF';
        } else {
            color.border = '#007E0D';
            color.status = '#007E0D';
        }
        return color;
    }

    getTelematic = () => {
        const telematic = this.get('telematic');
        const position = this.get('position');
        const telematicList = {};
        const date = moment(this.get('date')).valueOf();
        let speed = this.get('speedKmh');
        const formatter = new Monet.Format.DISTANCE(speed);

        if (Monet.Session.User.unitSystem === 'NON_METRIC') {
            speed = formatter.convertKmToMiles().format().getValue();
        }

        telematicList['speed'] = {
            value: speed,
            position: {
                lat: position.latitude,
                lng: position.longitude
            },
            date: date
        };

        if (telematic) {
            for (let key in telematic) {
                telematicList[key] = {
                    value: telematic[key],
                    position: {
                        lat: position.latitude,
                        lng: position.longitude
                    },
                    date: date
                };
            }
        }
        return telematicList;
    }
}

App.Models.Coordinate = CoordinateModel;

/* Collection */
class CoordinateCollection extends App.Collections.BaseCollection {
    url = `Route/${this.routeId}/Coordinates`;
    model = App.Models.Coordinate;

    constructor(routeId) {
        super();
        routeId && (this.routeId = routeId);
    }

    getTelematicsList = () => {
        const telematicsList = {};

        this.models.forEach(model => {
            const telematicsFromModel = model.getTelematic();
            for (let key in telematicsFromModel) {
                if (!telematicsList[key]) {
                    telematicsList[key] = [];
                }
                telematicsList[key].push(telematicsFromModel[key]);
            }
        });
        return telematicsList;
    }

    sortCoordinatesByDate = () => {
        return this.models.sort(sortCoordinatesByDate);
    }

    filterCoordinatesByEquipmentStoppedByMinutes = (minutes) => {
        const coordinates = [];
        let indexLastPosition = 0;

        const getNextCoordinateInMoviment = (index, list) => {
            let nextCoordinateMoving = null;
            for (let i = (index + 1); i < list.length; i++) {
                if (list[i].get('speedKmh') > 5 && !list[i].get('stoppedSince')) {
                    nextCoordinateMoving = list[i];
                    indexLastPosition = i;
                    break;
                }
            }
            return nextCoordinateMoving;
        };

        this.sortCoordinatesByDate().forEach((item, index, list) => {
            const coordinate = item;
            const previousCoordinate = list[index - 1];
            const coordinateStoppedSince = coordinate.get('stoppedSince');
            const previousCoordinateStoppedSince = previousCoordinate && previousCoordinate.get('stoppedSince');

            if(coordinateStoppedSince && !previousCoordinateStoppedSince && index >= indexLastPosition) {
                const nextCoordinateMoving = getNextCoordinateInMoviment(index, list);
                if (nextCoordinateMoving) {
                    const millisecondsDateNextCoordinate = Monet.Format.DateTime.parse(nextCoordinateMoving.get('date')).getTime();
                    const millisecondsActualCoordinate = Monet.Format.DateTime.parse(coordinateStoppedSince).getTime();
                    const timeStopped = (millisecondsDateNextCoordinate - millisecondsActualCoordinate);
                    const timeToFilter = minutes * 60000;

                    if (timeStopped >= timeToFilter) {
                        coordinate.set({ 'diffTime': timeStopped });
                        coordinate.set({ 'nextCoordinateDate': millisecondsDateNextCoordinate });
                        coordinate.set({ 'nextCoordinatePosition': nextCoordinateMoving.get('position') });
                        coordinates.push(coordinate);
                    }
                }
            }
        });
        return coordinates;
    }
}

App.Collections.Coordinates = CoordinateCollection;

/* Router */
class CoordinateRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'Coordinate';
        const model = App.Models.Coordinate;
        const collectionClass = App.Collections.Coordinates;

        super(entityName, model, collectionClass);
    }
}

App.Routers.Coordinate = CoordinateRouter;
